import React, { Component } from "react";
import { Modal, Button, Row } from "react-bootstrap";
import TextField from "../base_components/TextField";
import BooleanField from "../base_components/BooleanField";
import DateField from "../base_components/DateField";
import SelectField from "../base_components/SelectField";
import {connect, useDispatch, useSelector} from "react-redux";
import AutoSave from "../components/AutoSave"

const GeneralAffiliateMemberFormModal = (props) => {
  const { show } = useSelector((state) => state.ui.generalModal);
  const { organization } = useSelector((state) => state);
  const dispatch = useDispatch();
  const statuses = props.statusesOptions.map((status) => ({
    value: status,
    label: status,
  }));
  const states = props.stateOptions.map((state) => ({
    value: state,
    label: state,
  }));
  
  const { autoSaveAffiliateMember, autoSaveAffiliateMemberDetail, autoSaveAffiliateMemberAddress } = AutoSave();

  const handleClose = () => {
    dispatch({ type: "CLOSE_RESOURCE_MODAL", payload: { resourceName: "general" } })
    dispatch({ type: "TOGGLE_ACTION" })
  };
  
  const handleUpdate = () => {
    autoSaveAffiliateMember();
    autoSaveAffiliateMemberDetail();
    autoSaveAffiliateMemberAddress();
    handleClose();
  };

  return (
    <Modal show={show} onHide={() => handleClose()}>
      <Modal.Header closeButton>
        <div>
          <Modal.Title>Edit Member</Modal.Title>
          <p class="mb-0">Every field with an * is required</p>
        </div>
      </Modal.Header>
      <Modal.Body className="affiliate-member-detail">
        <Row>
          <TextField
            name="organization_name"
            label="Name of Organization"
            required="true"
            action="edit"
            col={6}
            resource="affiliateMemberDetail"
          />
          <TextField
            name="website"
            label="Website"
            action="edit"
            col={6}
          />
          <TextField
            name="name"
            label="Contact Name"
            resource="affiliateMember"
            action="edit"
            col={6}
          />
          <TextField
            name="email"
            label="Contact Email"
            action="edit"
            required="true"
            col={6}
          />
          <TextField
            name="phone_number"
            label="Primary Phone Number"
            action="edit"
            col={6}
          />
          <TextField
            name="street"
            label="Street Address"
            action="edit"
            resource="affiliateMemberAddress"
            col={6}
          />
          <TextField
            name="city"
            label="City"
            action="edit"
            resource="affiliateMemberAddress"
            col={6}
          />
          <SelectField
            name="state"
            label="State"
            action="edit"
            options={states}
            resource="affiliateMemberAddress"
            col={6}
          />
          <TextField
            name="zipcode"
            label="Zipcode"
            action="edit"
            resource="affiliateMemberAddress"
            col={6}
          />
          <DateField
            name="linked_at"
            label="Join Date"
            action="edit"
            resource="affiliateMember"
            col={6}
          />
          <TextField
            name="provider_id"
            label="Provider ID"
            action="edit"
            resource="affiliateMemberDetail"
            col={6}
          />
          <TextField
            name="legal_entity_name"
            label="Legal Entity Name"
            action="edit"
            resource="affiliateMemberDetail"
            col={6}
          />
          <TextField
            name="crra"
            label="CRRA"
            action="edit"
            resource="affiliateMemberDetail"
            col={6}
          />
          <TextField
            name="types_of_organizations"
            label="Type of Organization"
            action="edit"
            resource="affiliateMemberDetail"
            col={6}
          />
          <TextField
            name="billing_address"
            label="Company Billing Address"
            action="edit"
            resource="affiliateMemberDetail"
            col={6}
          />
          <TextField
            name="billing_address"
            label="Company Billing Address"
            action="edit"
            resource="affiliateMemberDetail"
            col={6}
          />
          <TextField
            name="number_of_residences"
            label="Number of Residences"
            action="edit"
            resource="affiliateMemberDetail"
            col={6}
          />
          <BooleanField name="healthcare_ownership" label="Healthcare Ownership" action="edit" resource="affiliateMemberDetail" col={6}/>
          <BooleanField name="scholarship" label="Scholarship" action="edit" resource="affiliateMemberDetail" col={6}/>
          <BooleanField name="certified_residence_requirements" label="Certified Residence Requirements" action="edit" resource="affiliateMemberDetail" col={6}/>
          <BooleanField name="narr_agreement" label="NARR Agreement" action="edit" resource="affiliateMemberDetail" col={6}/>
          <BooleanField name="lab_ownership" label="Lab Ownership" action="edit" resource="affiliateMemberDetail" col={6}/>
          <SelectField
            name="statuses"
            label="Status"
            action="edit"
            options={statuses}
            resource="affiliateMemberDetail"
            col={6}
            multiselect={true}
            addNew={true}
          />
          {organization?.name === "MASH" && (
            <TextField
              name="business_entity_name"
              label="Name of Business Entity (if different from Organization Name)"
              action="edit"
              resource="affiliateMemberDetail"
              col={6}
            />
          )}
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => handleClose()}>
          Close
        </Button>
        <Button variant="info" onClick={() => handleUpdate()}>
          Update
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default GeneralAffiliateMemberFormModal;
